












































































































































































































































import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'Tutorial',
})
export default class Tutorial extends Vue {
    public stepper: number = 1;

    public doneClick() {
        this.$store.commit('mutateShowTutorial', false);
    }
}
